// extracted by mini-css-extract-plugin
export default {"row":"AddElement_row__FCOkM","BasketToCardButtonContainer":"AddElement_BasketToCardButtonContainer__-j+g3","BasketToCardButton":"AddElement_BasketToCardButton__MoL9x"};